import React from "react";
import "./ApprovalWorkflow.css";

/**
 * Approval History Component
 * Displays approval audit trail in a table format
 */
const ApprovalHistory = ({ history }) => {
  if (!history || history.length === 0) {
    return (
      <div className="approval-history">
        <div className="approval-history-header">
          <h3>APPROVAL HISTORY</h3>
        </div>
        <div className="approval-history-empty">
          <p>No approval actions recorded yet.</p>
        </div>
      </div>
    );
  }

  const formatTimestamp = (timestamp) => {
    if (!timestamp) return "—";
    try {
      const date = new Date(timestamp);
      return date.toLocaleString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        timeZone: "UTC",
      }) + " UTC";
    } catch (e) {
      return timestamp;
    }
  };

  const getActionBadgeClass = (action) => {
    if (action === "Approved") return "approval-history-badge--approved";
    if (action === "Rejected") return "approval-history-badge--rejected";
    if (action === "Submitted") return "approval-history-badge--submitted";
    if (action === "Notified") return "approval-history-badge--notified";
    if (action === "Awaiting") return "approval-history-badge--awaiting";
    return "";
  };

  return (
    <div className="approval-history">
      <div className="approval-history-header">
        <h3>APPROVAL HISTORY</h3>
      </div>

      <div className="approval-history-table-wrapper">
        <table className="approval-history-table">
          <thead>
            <tr>
              <th>STAGE</th>
              <th>ACTOR</th>
              <th>ACTION</th>
              <th>TIMESTAMP</th>
              <th>COMMENT</th>
            </tr>
          </thead>
          <tbody>
            {history.map((entry, index) => (
              <tr key={index}>
                <td>{entry.stage || "—"}</td>
                <td>{entry.actor || "—"}</td>
                <td>
                  <span className={`approval-history-badge ${getActionBadgeClass(entry.action)}`}>
                    {entry.action || "—"}
                  </span>
                </td>
                <td>{formatTimestamp(entry.timestamp)}</td>
                <td className="approval-history-comment">
                  {entry.comment || "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ApprovalHistory;
